import React from "react";
import { ModalShell } from "./ModalShell";
import { BASE_URLS } from "../../config/urls";

export function NeedAuthModal({
                                  isOpen,
                                  onClose,
                              }: {
    isOpen: boolean;
    onClose: () => void;
}) {
    if (!isOpen) return null;

    return (
        <ModalShell
            title="Нужна авторизация"
            subtitle="Чтобы записаться на поставку — войдите в аккаунт"
            onClose={onClose}
        >

            <div className="profile-modal-actions" style={{ marginTop: 16 }}>
                <button className="btn-secondary" type="button" onClick={onClose}>
                    Закрыть
                </button>

                <button
                    className="btn-primary"
                    type="button"
                    style={{boxShadow: "none"}}
                    onClick={() => window.location.assign(`${BASE_URLS.app}/login`)}
                >
                    Войти
                </button>
            </div>
        </ModalShell>
    );
}
